// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"995e6997","22":"4503d493","70":"036d6d32","96":"1dbff271","207":"2e82f4c8","294":"2988cee2","384":"9f82e024","408":"f08654bc","463":"6f28c376","501":"1e25d1ab","734":"883015e2","972":"be93ed75","979":"2a7abeab"}[chunkId] + ".chunk.css";
};